import type { Router } from "@/typeDefinitions/custom/Router";

const router: Router.LicensedRouterExportType = [
  {
    path: "/organization",
    name: "Organization",
    redirect: { name: "Site" },
    children: [
      {
        path: "site",
        name: "Site",
        redirect: { name: "Departments" },
        children: [
          {
            path: "departments/:siteId(\\d+)?",
            name: "Departments",
            component: () => import("./views/OGDepartmentView.vue"),
            meta: {
              rights: ["systemSettings.admin"],
            },
            props: (route) => ({
              siteId: route.params.siteId ? Number(route.params.siteId) : undefined,
            }),
          },
          {
            path: "list",
            name: "SiteList",
            component: () => import("../../views/SiteList.vue"),
          },
          {
            path: "create",
            name: "SiteCreate",
            component: () => import("../../views/CreateSite.vue"),
            meta: {
              rights: ["systemSettings.admin"],
            },
          },
          {
            path: "update/:id(\\d+)",
            name: "SiteUpdate",
            component: () => import("../../views/UpdateSite.vue"),
            meta: {
              rights: ["systemSettings.admin"],
            },
            props: (route) => ({
              id: Number(route.params.id),
            }),
          },
        ],
      },
      {
        path: "costCenter",
        name: "CostCenter",
        redirect: { name: "CostCenterList" },
        children: [
          {
            path: "list",
            name: "CostCenterList",
            component: () => import("./views/OGCostCenterList.vue"),
            meta: {
              rights: ["systemSettings.admin"],
            },
          },
          {
            path: "create/:siteId(\\d+)?",
            name: "CostCenterCreate",
            component: () => import("./views/OGCostCenterCreate.vue"),
            meta: {
              rights: ["systemSettings.admin"],
            },
            props: (route) => ({
              showInModal: route.query.showInModal === "true",
              siteId: route.params.siteId ? Number(route.params.siteId) : undefined,
            }),
          },
          {
            path: "update/:id(\\d+)",
            name: "CostCenterUpdate",
            component: () => import("./views/OGCostCenterUpdate.vue"),
            meta: {
              rights: ["systemSettings.admin"],
            },
            props: (route) => ({
              id: Number(route.params.id),
            }),
          },
        ],
      },
      {
        path: "technicalPlace",
        name: "TechnicalPlace",
        redirect: { name: "TechnicalPlaceList" },
        children: [
          {
            path: "list",
            name: "TechnicalPlaceList",
            component: () => import("./views/OGTechnicalPlaceList.vue"),
            meta: {
              rights: ["systemSettings.admin"],
            },
          },
          {
            path: "create/:siteId(\\d+)?",
            name: "TechnicalPlaceCreate",
            component: () => import("./views/OGTechnicalPlaceCreate.vue"),
            meta: {
              rights: ["systemSettings.admin"],
            },
            props: (route) => ({
              showInModal: route.query.showInModal === "true",
              siteId: route.params.siteId ? Number(route.params.siteId) : undefined,
            }),
          },
          {
            path: "update/:id(\\d+)",
            name: "TechnicalPlaceUpdate",
            component: () => import("./views/OGTechnicalPlaceUpdate.vue"),
            meta: {
              rights: ["systemSettings.admin"],
            },
            props: (route) => ({
              id: Number(route.params.id),
            }),
          },
        ],
      },
    ],
  },
  // Legacy routes
  {
    path: "/holidays",
    name: "Holidays",
    component: () => import("./components/HolidayList.vue"),
    meta: {
      rights: ["systemSettings.admin"],
    },
  },
  {
    path: "/user/:createAnonym",
    component: () => import("./views/UserCreate.vue"),
    name: "CreateUser",
    props: (route) => ({
      createAnonym: route.params.createAnonym === "true",
    }),
    meta: {
      rights: ["user.admin"],
    },
  },
  {
    path: "/userUpdate/:id",
    component: () => import("./views/UserUpdate.vue"),
    name: "UpdateUser",
    props: (route) => ({
      id: Number(route.params.id),
    }),
    meta: {
      authorizationSiteResource: "user",
    },
  },
  {
    path: "/users",
    name: "users",
    component: () => import("./views/UserList.vue"),
    meta: {
      rights: ["user.admin"],
    },
  },
  {
    path: "/contacts",
    name: "LISAContacts",
    component: () => import("./views/LISAContacts.vue"),
  },
];

export default router;
